function getInsta(){
    jQuery.post({
        url: "/s/wp-admin/admin-ajax.php?action=get_instagram_latest_pictures",
        dataType: 'json',
        success: function(data) {
            for (var i = 0 ; i < 5 ; i++) {
                var imgUrl = data.data[i].images.standard_resolution.url;
				var imgUrl = imgUrl;
                var div = $('<li><div class="item js-async-bg not-loaded" src="" data-src="'+ imgUrl +'"></li>');
                jQuery('.js-insta ul').append(div);
            }                
        },
        complete: function(){
        	asyncBg();
        },
        error: function(err) {
        }
    });
};

function getFacebook(){
    jQuery.post({
        url: "/s/wp-admin/admin-ajax.php?action=get_facebook_latest_posts",
        dataType: 'json',
        success: function(data) {
            for (var i = 0 ; i < 3 ; i++) {
                var message = ''; 
                if(typeof data.posts.data[i].message != 'undefined'){              	
                	var message = data.posts.data[i].message.trimToLength(200);
                }
                var imgUrl = data.posts.data[i].attachments.data[0].media.image.src;
                var username = data.username;
                var name = data.name;
                var link = data.posts.data[i].permalink_url;
                var div = $('<div class="col-sm-4 Card--facebook mbm mbn-sm phn phs-sm phm-md"><a href="https://www.facebook.com/'+ username +'" target="_blank" title="@'+ name +'" class="author"><i class="icon-social-facebook"></i><span>@'+ name +'</span></a><a class="post-link" target="_blank" href="'+ link +'"><div class="excerpt"><p>'+ message +'</p><img class="js-async-img not-loaded" src="" data-src="'+ imgUrl +'"></div></a></div>');
                jQuery('.js-facebook').append(div);
            }                
        },
        complete: function(){
        	asyncImg();
        },
        error: function(err) {
        }
    });
};

function getTwitter(){
    jQuery.post({
        url: "/s/wp-admin/admin-ajax.php?action=get_twitter_latest_tweets",
        dataType: 'json',
        success: function(data) {
            for (var i = 0 ; i < 3 ; i++) {
                var message = data[i].text;
                var username = data[i].user.screen_name;
                var link = "https://twitter.com/statuses/" + data[i].id_str;
                var div = $('<div class="col-sm-4 Card--tweet mbm mbn-sm phn phs-sm phm-md"><a href="https://twitter.com/'+ username +'" target="_blank" title="@'+ username +'" class="author"><i class="icon-social-twitter"></i> @'+ username +'</a><a href="'+ link +'" class="post-link" target="_blank"><p class="excerpt">' + message + '</p></a></div>');
                jQuery('.js-twitter').append(div);
            }                
        },
        complete: function(){
        	asyncImg();
        }
    });
};